import { FormSectionWrapper } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/PaymentIntent/Multilender/MerchantPos/MerchantPosForm/components/_shared/FormSectionWrapper';
import { useMerchantPos } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/PaymentIntent/Multilender/MerchantPos/MerchantPosForm/hooks/useMerchantPos';
import { ProfessionalDetailsForm as ProfessionalDetails } from '@/components/modules/KYC/KYCLoan/BorrowerKYC/components/ProfessionalDetailsSection/components/ProfessionalDetailsForm';
import { FormGridOptions } from '@/components/shared/components/FormGridContainer/types/formGridOptions';

export interface ProfessionalDetailsFormProps extends FormGridOptions {}

export const ProfessionalDetailsForm = ({ fieldVariant, fullWidth, direction }: ProfessionalDetailsFormProps) => {
  const { additionalProfessionalDetailsRequired, isCompanyCifRequired, currency } = useMerchantPos();

  return (
    <FormSectionWrapper titleTid="PROFESSIONAL_DETAILS">
      <ProfessionalDetails
        currency={currency}
        additionalProfessionalDetailsRequired={additionalProfessionalDetailsRequired}
        isCompanyCifRequired={isCompanyCifRequired}
        fieldVariant={fieldVariant}
        fullWidth={fullWidth}
        direction={direction}
      />
    </FormSectionWrapper>
  );
};
